import type { ReactNode } from 'react';

import styles from './empty-state.module.scss';

export type EmptyStateProps = {
  /** Illustration / icon node (e.g. a Phosphor icon at ~48px). */
  icon?: ReactNode;
  /** Drop the muted circle behind the icon (for self-contained illustration images). */
  bareIcon?: boolean;
  title: string;
  description?: ReactNode;
  /** Optional primary action (e.g. a Button or link). */
  action?: ReactNode;
  className?: string;
};

/** Centered empty / no-results placeholder. Used by the device list (no devices,
 *  no search matches) and the notification center. */
export function EmptyState({
  icon,
  bareIcon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div className={[styles.root, className].filter(Boolean).join(' ')} role="status">
      {icon ? (
        <div
          className={[styles.icon, bareIcon ? styles.iconBare : undefined]
            .filter(Boolean)
            .join(' ')}
        >
          {icon}
        </div>
      ) : null}
      <p className={styles.title}>{title}</p>
      {description ? <p className={styles.description}>{description}</p> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}
